<template>
    <div class="footer">
        <p>客户服务电话：400-6500-180</p>
        <p>©️2015 KEER Co.，Ltd.</p>
        <p>京ICP备13022809号-1</p>
        <p>京公网安备 1101010200197</p>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: .2rem;
    padding-bottom: .3rem;
    font-size: .1rem;
    > p {
        margin-right: 3px;
        color: #bebebe;
    }
}
</style>
